import './dsCSS.css';
import './myCss.css';
import Tanzania from './images/Tanzania.jpg'
import Beijing from './images/Beijing.jpg'
import ALM from './images/ALM.jpg'
import earthquake from './images/earthquake.jpg'
import { Link } from 'react-router-dom'


const DataScience = () => {
    return (
        
      <div className= 'tab-intro-wallpaper'>
            <h1 className='description-ds'>
                My entry in to tech began as a Data Science student at the <span id='college'>Flatiron School</span> in NYC. Please see Data Science portfolio <a className = 'ds-portfolio' href='https://jeffreyng512137e14.myportfolio.com/' target='_blank' rel='noreferrer'><span >here.</span></a></h1>

        <h1 className='description-ds'>
            {/* Projects */}
        </h1>
        <div className='grid-container-ds'>
            <div className='grid-item-ds'>
                <h4 id="latest">Earthquake Forecasting</h4>
                <img className="photo-project-1" src={earthquake} alt='earthquake'/>

                <h5>Techstack: Keras, Tensorflow, Seaborn, Time Series Modeling </h5>
                <h3 className="text"><a href="https://github.com/halujeff5/EarthquakeProj" className='link-to-proj'
                    target="_blank" rel='noreferrer'>Code</a>

                    <a href="https://docs.google.com/presentation/d/1pIqk5-NN86szZGaZgWNKM681LFEsrW0e_aU3tUp7fM4/edit?slide=id.g8f59c23fc9_0_47#slide=id.g8f59c23fc9_0_47" className='link-to-proj'
                        target="_blank" rel='noreferrer'>Presentation</a>
                </h3>
            </div>
            <div className="grid-item-ds">
                <h4 id="latest">Political Platform Sentiment Analysis Using NLP</h4>
                <img className="photo-project-1" src={ALM} alt='ALM'/>
                <h5>Techstack: Gensim, Naive Bayes Model, Vader</h5>

                <h3 className="text"><a className='link-to-proj' href="https://jeffreyng512137e14.myportfolio.com/alllivesmatter-nlp-analysis"
                    target="_blank" rel='noreferrer'>Presentation</a>
                    <a className='link-to-proj' href='https://github.com/halujeff5/AllLivesMatter-Project/tree/jeffng'
                        target="_blank" rel='noreferrer'>Code</a>
                </h3>
            </div>

            <div className='grid-item-ds'>
                <h4 id='latest'>Beijing Air Quality</h4>

                <img className="photo-project" src={Beijing} alt='Beijing'/>
                <h5>Techstack: Seaborn, LSTM, Prophet</h5>
                <h3 className='text'><a className='link-to-proj' href = 'https://jeffreyng512137e14.myportfolio.com/beijing-air-quality' target= '_blank' rel= 'noreferrer'>Presentation</a> <a
                    href='https://github.com/halujeff5/Beijing_Air_Quality' target ='_blank' rel='noreferrer' className='link-to-proj'>Code</a></h3>

            </div>
            <div className='grid-item-ds'>
                <h4 id='latest'>Tanzanian Water Well Crisis</h4>
                <img className="photo-project-1" src={Tanzania} alt='Tanzania'/>
                <h5>Techstack: Random Forest, Seaborn, SciKit-Learn </h5>
                <h3 className='text'>
                    <a className='link-to-proj'
                        href='https://jeffreyng512137e14.myportfolio.com/a-regression-analysis-on-national-park-trails-1' target="_blank" rel='noreferrer'>Presentation</a>
                    <a href="https://github.com/halujeff5/TanzanianWaterWellCrisis" class='title-link'
                        target="_blank" rel='noreferrer'>Code</a>
                </h3>

            </div>
        </div>


        <div>
            <h1 className='description-ds-bottom'><Link to='/'>Home</Link></h1>
        </div>
        </div>
    )
}

export default DataScience
